function getLang() {
  return [
    {code: 'zh', text: '中文'},
    {code: 'en', text: 'English'}
  ]
}

export default getLang()



// WEBPACK FOOTER //
// ./src/lib/i18n.js